// extracted by mini-css-extract-plugin
export default {"solutions":"Solutions_solutions__k4okO","blocks":"Solutions_blocks__SeMu5","arrow-block":"Solutions_arrow-block__uXgiV","arrow":"Solutions_arrow__hf5Vr"};